module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "highscore"
  }, [_c('h2', [_vm._v("Highscore")]), _vm._v(" "), _c('div', {
    staticClass: "scores"
  }, _vm._l((_vm.list), function(highscore, index) {
    return _c('div', {
      staticClass: "highscore-row",
      class: {
        'me': highscore[0] === _vm.playerName
      }
    }, [(index >= 3) ? _c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(parseFloat(index) + 1) + ".")]) : _vm._e(), _vm._v(" "), (index < 3) ? _c('div', {
      staticClass: "number",
      class: ("trophy" + index)
    }, [_c('i', {
      staticClass: "fa fa-trophy"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(highscore.name.name))]), _vm._v(" "), _c('div', {
      staticClass: "score"
    }, [_vm._v(_vm._s(_vm._f("format")(highscore.score)))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "menu-bar"
  }, [_c('span', {
    class: {
      'active': _vm.view === 'score'
    },
    on: {
      "click": function($event) {
        _vm.view = 'score'
      }
    }
  }, [_vm._v("Highest score")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.view === 'played'
    },
    on: {
      "click": function($event) {
        _vm.view = 'played'
      }
    }
  }, [_vm._v("Most played")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e19a31b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Highscore.vue
// module id = 113
// module chunks = 1